import { render, staticRenderFns } from "./AdminSchool.vue?vue&type=template&id=40591954&scoped=true&"
import script from "./AdminSchool.vue?vue&type=script&lang=js&"
export * from "./AdminSchool.vue?vue&type=script&lang=js&"
import style0 from "./AdminSchool.vue?vue&type=style&index=0&id=40591954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40591954",
  null
  
)

export default component.exports